import { render, staticRenderFns } from "./BillingAddressReadOnlyTemplate.vue?vue&type=template&id=287eb181&"
import script from "./BillingAddressReadOnlyTemplate.vue?vue&type=script&lang=js&"
export * from "./BillingAddressReadOnlyTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports